import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { NavigationState } from '@osos/shared/legacy-core';
import { LinkPresenterModel } from '@osos/shared/types';
import { ComponentBase } from '@osos/shared/utility';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-search-menu',
  templateUrl: './search-menu.component.html',
  styleUrls: ['./search-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SearchMenuComponent extends ComponentBase {
  searchValue = '';

  @Output() clicked: EventEmitter<any> = new EventEmitter();

  pinnedViews$: Observable<LinkPresenterModel[]>;

  @ViewChild('search', { static: false })
  set input(element: ElementRef<HTMLInputElement>) {
    if (element) {
      element.nativeElement.focus();
    }
  }
  constructor(store: Store) {
    super();
    this.pinnedViews$ = store
      .select(NavigationState.navigationItemsV2)
      .pipe(map((nav) => nav.links));
  }

  clearSearch() {
    this.searchValue = '';
  }

  getIcon(item) {
    return item?.icon?.name ?? 'home';
  }

  onItemClicked() {
    this.clicked.emit();
  }
}
